export const GOOGLE_MAP_API_KEY = "AIzaSyCORh_lw8WYKGKuYzUhzNrcQRPAJ4Jr70E";
export const GOOGLE_RECAPTCHA_SITE_KEY = "6LeEobMZAAAAABc7nM7UvL00c6tOqh90qTeErT-v";
// export const GOOGLE_RECAPTCHA_SITE_KEY =
// "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"; //For testing purposes by google
